if (window.theme.pageType == 'product') {
	
    var jsonData = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
	if (jsonData.product.available) {
		// Afterpay
		Afterpay.init(jQuery);
	}	
}

$(document).on('click', '[data-action="quick-add-to-cart"]', function () {
   var qty = 1;
   var id = $(this).attr('data-variant-id');

    var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: qty,
            id: id,
        },
        dataType: 'json',
        success: function(line_item) { 
            document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                    quantity: qty
                }
            }));
			if (window.location.href.indexOf("wishlist") > -1) {
				console.log('trigger remove of item from wishlist.');
		    }
        },
     };
     $.ajax(params);
});

$( document ).ready(function() {
	var announcementCarousel = $('#section-announcement-secondary .Carousel');
	if (announcementCarousel.length > 0) {
		var config = JSON.parse(announcementCarousel.attr('data-flickity-config'));
		var flkty = new Flickity( $(announcementCarousel)[0], config);
		$('.js #section-announcement-secondary .Slideshow__Carousel .Slideshow__Slide').css('visibility','visible')
	}
});

